import {
    faDashboard,
    faGears,
    faHome,
   faUser,
   faMusic,
   faShoppingCart,
   faUpload,
   faDollarSign
} from "@fortawesome/free-solid-svg-icons";
import Dashboard from "../../components/Dashboard/Main";

const userDashboard = (props) => {
  const links = [
    {
      name: "Dashboard",
      url: "/user/my-dashboard",
      icon: faDashboard,
    },
    {
      name: "All Music",
      url: "/user/my-dashboard/music/all",
      icon: faMusic,
    },
    {
      name: "Upload Music",
      url: "/user/upload-music",
      icon: faUpload,
    },
    {
      name: "My Profile",
      url: "/user/my-profile",
      icon: faUser,
    },
    {
      name: "Subscriptions",
      url: "/user/my-subscription-history",
      icon:faShoppingCart
    },
    {
      name: "Royalties",
      url: "/user/my-royalties/me",
      icon:faDollarSign 
    },
    {
      name: "Settings",
      url: "/user/my-dashboard/settings",
      icon: faGears,
    },
    {
      name: "Home",
      url: "/",
      icon: faHome,
    }
  ]
  
  const navLinks=[
    { name: "Me", url: "/user/my-profile", icon: faUser },
  ]
    return ( <Dashboard sidebarLinks={links} navBarTitle={"My Dashboard"} navLinks={navLinks}> {props.children} </Dashboard>);
}
 
export default userDashboard;